@if (isLoading) {
  <div class="display-flex justify-content-center my--xl">
    <mat-spinner class="primary-spinner"></mat-spinner>
  </div>
} @else if (report) {
  <div class="grid grid--2">
    <app-revenue-report class="display-column-flex" [report]="report.revenue" [selectedRange]="selectedRange">
    </app-revenue-report>
    <app-commission-estimate-report
      class="display-column-flex"
      [report]="report.payouts"
      [selectedRange]="selectedRange"
      [compact]="true"
      [usePayoutTerminology]="true">
    </app-commission-estimate-report>
  </div>
  @if (hasData && report.locations.length) {
    <mat-card class="mt--md">
      <mat-card-header>
        <mat-card-title>{{ 'App.Admin.Dashboard.Revenue.FinancialsByLocation' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-financial-overview-table [locations]="report.locations"></app-financial-overview-table>
      </mat-card-content>
    </mat-card>
  }
}
